
<template>
    <h1>Application</h1>
    <v-form v-model="valid" ref="form">

        <div v-if="unregistered" style="text-align: left;">
            <span style="color: red; text-align: left;">
                You are currently not registered, or not logged in. You will be unable to track any application submitted through this site unless you are
                <router-link :to="{ name: 'register' }">registered</router-link> and <router-link :to="{ name: 'login' }">logged in</router-link>.
            </span>
        </div>
        <div v-else-if="registered">
            <span style="color: green; text-align: left;">
                You are currently registered and logged in, 
            </span>
            <span v-if="!hasNoApplication">
                <span style="color: green;">and your application has been successfully submitted. You can track any application submitted through this site by going to the <router-link :to="{ name: 'application-status' }">Application Status</router-link> page.<br /><br /></span>
                <h3>
                    Application Status:
                    <span style="color: royalblue;" v-if="statusPending">PENDING</span>
                    <span style="color: orangered;" v-if="statusMoreInfo">MORE INFORMATION REQUIRED</span>
                    <span style="color: darkred;" v-if="statusDeclined">DECLINED</span>
                    <span style="color: green;" v-if="statusAccepted">ACCEPTED</span>
                </h3>
                <span style="color: orangered;" v-if="statusMoreInfo">Your application requires additional information in order to be processed. Please see notes below, make the necessary
                updates, and click 'Submit Updates' at the bottom of the page.</span><br />
                <span v-html="!existingApp.applicationResultNote || existingApp.applicationResultNote.trim() === '' ? '' : '<b>Notes:</b> ' + existingApp.applicationResultNote + '<br /><br />'"></span>
                Please review submitted information below:
            </span>
            <span v-if="hasNoApplication" style="color: green;">but your application has not yet been submitted.<br /><br /></span>
        </div>
        <div v-if="loadingData">Loading...</div>
        <v-container v-else density="compact" style="text-align: left;">
            <div density="compact" style="text-align: left;" v-if="!registered">
                <v-row>
                    <v-col cols="12"
                           md="8">

                    </v-col>
                </v-row>
            </div>
            <v-row v-if="!hasNoApplication">
                <v-col>
                    <b>Application Date:</b> {{ new Date(existingApp.applicationDate).toLocaleDateString('en-US') }}
                </v-col>
                <v-col>
                    <b>Program Applied For:</b> {{ existingApp.waiverProgramName}}
                </v-col>
            </v-row>
            <div v-if="registered">
                <v-row>
                    <v-col cols="4"
                           md="4">
                        Which waiver program are you applying for?
                        <v-select v-model="divisionId" :items="divisions" item-value="divisionId" item-title="description" label="Waiver Program" @update:modelValue="onDivisionTypeChange">
                            <template v-slot:counter>
                            </template>
                        </v-select> <br />
                        <!--<ul>
                            <li v-for="item in divisions" :key="item.divisionId">
                                Short: {{ item.shortDescription }}
                            </li>
                        </ul>
                        <ul>
                            <li v-for="item in divisions" :key="item.divisionId">
                                Long: {{ item.description }}
                            </li>
                        </ul>
                        <ul>
                            <li v-for="item in divisions" :key="item.divisionId">
                                ID: {{ item.divisionId }}
                            </li>
                        </ul>-->
                    </v-col>
                </v-row>
                <v-row v-if="ccwFields" style="text-align: left; margin-top: -40px;" dense>
                    <v-col cols="40" md="12" style="text-align: left; margin-bottom: 10px;">
                        <b>CCW Waiver</b>
                        For more information about CCW Participant Services and Eligibility, please visit: <br />
                        <a href="https://health.wyo.gov/healthcarefin/hcbs/ccw-participant-services-and-eligibility/" target="_blank">https://health.wyo.gov/healthcarefin/hcbs/ccw-participant-services-and-eligibility/ (new window)</a>
                    </v-col>
                </v-row>
                <v-row v-if="ddFields" style="text-align: left; margin-top: -40px;">
                    <v-col cols="40" md="12" style="text-align: left; margin-bottom: 10px;">
                        <b>DD Waiver</b>
                        For more information about DD Participant Services and Eligibility, please visit: <br />
                        <a href="https://health.wyo.gov/healthcarefin/hcbs/dd-participant-services-and-eligibility/" target="_blank">https://health.wyo.gov/healthcarefin/hcbs/dd-participant-services-and-eligibility/ (new window)</a>
                    </v-col>
                </v-row>
                <v-row v-if="unknownWaiver" style="text-align: left; margin-top: -40px;">
                    <v-col cols="40" md="12" style="text-align: left; margin-bottom: 10px;">
                        <b>DD Waiver</b>
                        For more information about DD Participant Services and Eligibility, please visit: <br />
                        <a href="https://health.wyo.gov/healthcarefin/hcbs/dd-participant-services-and-eligibility/" target="_blank">https://health.wyo.gov/healthcarefin/hcbs/dd-participant-services-and-eligibility/ (new window)</a>
                        <br /><br />
                        <b>CCW Waiver</b>
                        For more information about CCW Participant Services and Eligibility, please visit: <br />
                        <a href="https://health.wyo.gov/healthcarefin/hcbs/ccw-participant-services-and-eligibility/" target="_blank">https://health.wyo.gov/healthcarefin/hcbs/ccw-participant-services-and-eligibility/ (new window)</a>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12"
                           md="4">
                        <v-text-field v-model="firstName" label="First Name"></v-text-field>
                    </v-col>
                    <v-col cols="12"
                           md="4">
                        <v-text-field v-model="middleName" label="Middle Name" clearable></v-text-field>
                    </v-col>
                    <v-col cols="12"
                           md="4">
                        <v-text-field v-model="lastName" label="Last Name"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="preferredName" label="Preferred Name" clearable></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-select :items="suffixes" v-model="suffixId" item-value="suffixId" item-title="description" name="suffix" label="Suffix" clearable>
                            <template v-slot:counter>
                            </template>
                        </v-select>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field v-model="dateOfBirth" label="Birth Date" type="date"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="ssn" label="SSN" v-maska:[ssnMask]></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-select :items="genderTypes" v-model="genderId" item-value="genderId" item-title="description" label="Gender">
                            <template v-slot:counter>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-select :items="ethnicities" v-model="ethnicityId" item-value="ethnicityId" item-title="description" name="ethnicity" label="Ethnicity">
                            <template v-slot:counter>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="medicaidId" label="Medicaid ID" v-maska:[medicaidIdMask]></v-text-field>
                    </v-col>
                    <v-col cols-="12" md="8">
                        <v-checkbox v-model="isMilitary" label="Are you, your spouse or parent a veteran or an active-duty member of the U.S. military?"></v-checkbox>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-select :items="counties" v-model="countyId" item-value="countyId" item-title="description" name="county" label="County">
                            <template v-slot:counter>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
                <v-card variant="outlined" title="Contact Info" class="text-left" style="margin-bottom: 10px;">
                    <div style="margin: 5px; padding-left: 10px;">
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-select :items="phoneTypes" v-model="phoneTypeId" item-value="phoneTypeId" item-title="description" name="phoneType" label="Phone Type">
                                    <template v-slot:counter>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="phoneNumber" label="Phone" placeholder="(000) 000-0000" v-maska:[phoneMask] />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-select :items="emailTypes" v-model="emailTypeId" item-value="emailTypeId" item-title="description" name="emailType" label="Email Type">
                                    <template v-slot:counter>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="emailAddress" label="Email" placeholder="johndoe@gmail.com" type="email" />
                            </v-col>
                        </v-row>
                    </div>
                </v-card>
                <v-card variant="outlined" title="Physical Address" class="text-left" style="margin-bottom: 10px;">
                    <div style="margin: 5px; padding-left: 10px;">
                        <!--<v-row dense>
                <v-col cols="11" md="4">
                    <v-select :items="addressTypes" v-model="addressTypeId" item-value="addressTypeId" item-title="description" name="addressType" label="Address Type">
                        <template v-slot:counter>
                        </template>
                    </v-select>
                </v-col>
            </v-row>-->
                        <v-row dense>
                            <v-col cols="11" md="4">
                                <v-text-field v-model="addressLine1" label="Address Line 1"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="11" md="4">
                                <v-text-field v-model="addressLine2" label="Address Line 2"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="8" md="4">
                                <v-text-field v-model="city" label="City"></v-text-field>
                            </v-col>
                            <v-col cols="8" md="4">
                                <v-select :items="states" v-model="stateId" item-value="stateId" item-title="description" name="state" label="State">
                                    <template v-slot:counter>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="8" md="4">
                                <v-text-field v-model="zipCode" label="Zip" />
                            </v-col>
                        </v-row>
                    </div>
                </v-card>
                <v-card variant="outlined" title="Mailing Address (if different from Physical Address)" class="text-left">
                    <div style="margin: 5px; padding-left: 10px;">
                        <v-checkbox v-model="showMailing" label="Do you have a different mailing address than the address entered above?"></v-checkbox>
                    </div>

                    <div v-if="showMailing" style="margin: 5px; padding-left: 10px;">
                        <v-row dense>
                            <v-col cols="11" md="4">
                                <v-text-field v-model="mailingAddressLine1" label="Address Line 1"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="11" md="4">
                                <v-text-field v-model="mailingAddressLine2" label="Address Line 2"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="8" md="4">
                                <v-text-field v-model="mailingCity" label="City"></v-text-field>
                            </v-col>
                            <v-col cols="8" md="4">
                                <v-select :items="states" v-model="mailingStateId" item-value="stateId" item-title="description" name="mailingState" label="State">
                                    <template v-slot:counter>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="8" md="4">
                                <v-text-field v-model="mailingZipCode" label="Zip" />
                            </v-col>
                        </v-row>
                    </div>
                </v-card>
                <v-row style="margin-top: 10px;">
                    <v-col cols="12" md="4">
                        <v-select :items="preferredMethodsOfContact" v-model="preferredMethodOfContactId" item-value="preferredMethodOfContactId" item-title="description"
                                  name="preferredMethodOfContact" label="Preferred Method Of Contact">
                            <template v-slot:counter>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols-="12" md="8">
                        <v-checkbox v-if="isOver21" v-model="isApplyingForAbi" label="Are you applying for the Acquired Brain Injury Waiver?"></v-checkbox>
                    </v-col>
                </v-row>
                <v-card variant="outlined" title="Emergency Contact Info" class="text-left" style="margin-bottom: 10px;">
                    <div style="margin: 5px; padding-left: 10px;">
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="emergencyContactName" label="Name" />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select :items="contactTypes" v-model="emergencyContactContactTypeId" item-value="contactTypeId" item-title="description"
                                          name="emergencyContactType" label="Contact Type">
                                    <template v-slot:counter>
                                    </template>
                                </v-select>
                            </v-col>
                        </v-row>
                    </div>
                    <!-- emergency contact phone/email -->
                    <div style="margin: 5px; padding-left: 10px;">
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-select :items="phoneTypes" v-model="emergencyContactPhoneTypeId" item-value="phoneTypeId" item-title="description" name="emergencyContactPhoneType" label="Phone Type">
                                    <template v-slot:counter>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="emergencyContactPhoneNumber" label="Phone" placeholder="(000) 000-0000" v-maska:[phoneMask] />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-select :items="emailTypes" v-model="emergencyContactEmailTypeId" item-value="emailTypeId" item-title="description" name="emergencyContactEmailType" label="Email Type">
                                    <template v-slot:counter>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="emergencyContactEmailAddress" label="Email" placeholder="johndoe@gmail.com" type="email" />
                            </v-col>
                        </v-row>
                    </div>
                    <!--emergency contact address-->
                    <div style="margin: 5px; padding-left: 10px;">
                        <v-row dense>
                            <v-col cols="11" md="4">
                                <v-select :items="addressTypes" v-model="emergencyContactAddressTypeId" item-value="addressTypeId" item-title="description" name="emergencyContactAddressType" label="Address Type">
                                    <template v-slot:counter>
                                    </template>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="11" md="4">
                                <v-text-field v-model="emergencyContactAddressLine1" label="Address Line 1"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="11" md="4">
                                <v-text-field v-model="emergencyContactAddressLine2" label="Address Line 2"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="8" md="4">
                                <v-text-field v-model="emergencyContactCity" label="City"></v-text-field>
                            </v-col>
                            <v-col cols="8" md="4">
                                <v-select :items="states" v-model="emergencyContactStateId" item-value="stateId" item-title="description" name="emergencyContactState" label="State">
                                    <template v-slot:counter>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="8" md="4">
                                <v-text-field v-model="emergencyContactZipCode" label="Zip" />
                            </v-col>
                        </v-row>
                    </div>
                    <div style="margin: 5px; padding-left: 10px;">
                        <v-row dense>
                            <v-col cols="12" md="4">
                                <v-select :items="preferredMethodsOfContact" v-model="emergencyContactPreferredMethodOfContactId" item-value="preferredMethodOfContactId" item-title="description"
                                          name="emergencyContactPreferredMethodOfContact" label="Preferred Method Of Contact">
                                    <template v-slot:counter>
                                    </template>
                                </v-select>
                            </v-col>
                        </v-row>
                    </div>
                </v-card>
                <v-card variant="outlined" title="Case Management Agency Selection" class="text-left" style="margin-bottom: 10px;">
                    <div style="margin: 5px; padding-left: 10px;">
                        <v-row dense cols="12" md="4">
                            <v-col cols="12" md="4">
                                <v-select :items="cmAgencies" v-model="cmAgencyWyNumber" item-value="wyNumber" item-title="providerName"
                                          name="cmAgencyWyNumberName" label="Case Management Agency">
                                    <template v-slot:counter>
                                    </template>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" md="4">
                                <span v-if="allowUpload">If you have a completed Case Management Selection form, please upload it here:</span>
                                <span v-if="!allowUpload && cmAgencyDocument && cmAgencyDocument.documentId && cmAgencyDocument.documentId > 0">View your uploaded CM Selection Form:</span>
                                <v-file-input v-if="allowUpload"
                                              label="Upload Document"
                                              accept=".pdf,.doc,.docx"
                                              @change="handleCmAgencyFileUpload"
                                              outlined
                                              dense></v-file-input>
                            </v-col>
                            <v-col v-if="ddFields" cols="12" md="4">
                                <a href="documents/CM07-Case-Management-Selection-Form.pdf" target="_blank">Download the the DD Case Management Selection Form</a>
                            </v-col>
                            <v-col v-if="ccwFields" cols="12" md="4">
                                <a href="documents/CCW-Form-06-Change-of-CMA-Form.pdf" target="_blank">Download the CCW Case Management Selection Form</a>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" md="4">
                                <v-btn v-if="cmAgencyDocument && cmAgencyDocument.documentId && cmAgencyDocument.documentId > 0"
                                       color="primary"
                                       text
                                       @click="downloadFile(cmAgencyDocument.contentBase64, cmAgencyDocument.filename, 'application/pdf')">
                                    <v-icon left>mdi-download</v-icon>
                                    {{ cmAgencyDocument.filename }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-card>
                <div v-if="hasErrors" style="color: red;">
                    <ul>
                        <li v-for="err in validationErrors" :key="err.text">
                            {{ err.text }}
                        </li>
                    </ul>
                </div>
                <div style="margin: 10px;">
                    <v-row>
                        <v-col cols="12" md="4"></v-col>
                        <v-col cols="12" md="4">
                            <v-btn @click="saveNewApplication" block color="indigo-darken-3" size="medium" variant="flat" v-if="hasNoApplication">Submit</v-btn>
                            <v-btn @click="updateApplication" block color="indigo-darken-3" size="medium" variant="flat" v-if="requiresEdit">Submit Updates</v-btn>
                        </v-col>

                    </v-row>
                </div>
            </div>
        </v-container>
    </v-form>
</template>

<script setup lang="ts">
    
    import { ref, onMounted, watch } from 'vue';
    //import { injectStrict } from '@/Services/Helper/inject-typed'
    //import { AxiosKey } from '@/Services/HttpClient/symbols'
    import { isAxiosError } from '@/Services/HttpClient/axios-plugin'
    import router from '@/Router/router'
    import { useAuth0 } from '@/Services/Auth0/auth0-plugin';
    import { Auth0 } from '@/Services/Auth0/auth0-interface'
    import { LookupService } from '@/Services/lookup-service';
    //import { IWaiverType } from '@/Models/IWaiverType';
    import { ParticipantApplicationService } from '@/Services/participant-application-service';
    import { UserService } from '@/Services/user-service';
    import { IParticipantNewApplication } from '@/Models/IParticipantNewApplication';
    import { IParticipantApplication } from '@/Models/IParticipantApplication';
    import { IUser } from '@/Models/IUser'
    import { IPerson } from '../Models/IPerson';
    import { IPersonAddress } from '../Models/IPersonAddress';
    import { IPersonEmail } from '../Models/IPersonEmail';
    import { IPersonPhone } from '../Models/IPersonPhone';
    import { IPersonEmergencyContact } from '../Models/IPersonEmergencyContact';
    import { IParticipantApplicationDocument } from '../Models/IParticipantApplicationDocument';
    import { IDocument } from '../Models/IDocument';
    import { PersonService } from '@/Services/person-service';
    import { PersonAddressService, createPersonAddress } from '@/Services/person-address-service';
    import { PersonEmailService } from '@/Services/person-email-service';
    import { PersonPhoneService } from '@/Services/person-phone-service';
    import { PersonEmergencyContactService, createPersonEmergencyContact } from '@/Services/person-emergency-contact-service';
    import { ParticipantApplicationDocumentService, createParticipantApplicationDocument } from '@/Services/participant-application-document-service';
    import { DocumentService, createDocument } from '@/Services/document-service';
    import { DateHelper } from '@/Services/Helper/date-helper';
    import { StateEnum } from '@/Enums/StateEnum';

    //import { useReCaptcha } from 'vue-recaptcha-v3'

    //let recaptchaInstance = useReCaptcha();
    
    //const recaptcha = async () => {
    //    await recaptchaInstance?.recaptchaLoaded();
    //    const token = await recaptchaInstance?.executeRecaptcha("submit_application");
    //    return token;
    //};
    //let captchaToken = recaptcha().then(token => {
    //    console.log("recaptcha token:", token);
    //});


    import { vMaska } from 'maska'
    const phoneMask = { mask: '(###) ###-####' }
    const ssnMask = { mask: '###-##-####' }
    const medicaidIdMask = { mask: '##-########'}

    const auth0: Auth0 | null = useAuth0();
    const getAccessToken = async () => {
        if (!auth0) {
            return null;
        }

        return await auth0.getAccessToken();
    };    

    //const axios = injectStrict(AxiosKey)
    //const form = ref(null)\
    const loadingData = ref(true)
    let isLoading = ref(true)
    let unregistered = ref(true)
    let registered = ref(false)
    let isAuthenticated = false
    let hasNoApplication = ref(true)
    let requiresEdit = ref(false)
    let auth0UserId = ref()
    let user = ref<IUser | null>(null);
    let auth0User = ref()
    let existingApp = ref<IParticipantApplication | null>(null)
    let participantPortalUserId = ref();

    let valid = true
    let hasErrors = ref(false)
    let validationErrors = ref<ValidationError[]>([]);
    let ccwFields = ref(false)
    let ddFields = ref(false)
    let unknownWaiver = ref(false)

    //const waiverTypes = ref([{}])
    const divisions = ref ([{}])
    const counties = ref([{}])
    const ethnicities = ref([{}])
    const genderTypes = ref([{}])
    const suffixes = ref([{}])
    const addressTypes = ref([{}])
    const states = ref([{}])   
    const phoneTypes = ref([{}]) 
    const emailTypes = ref([{}])
    const preferredMethodsOfContact = ref([{}])
    const contactTypes = ref([{}])
    const cmAgencies = ref([{}])

    //let participantApplication = ref<IParticipantApplication>()
    let firstName = ref('')
    let lastName = ref('')
    let preferredName = ref('')
    let suffixId = ref()
    let divisionId = ref()
    let middleName = ref('')
    let dateOfBirth = ref('')
    let isMilitary = ref(false)
    let isApplyingForAbi = ref(false)
    let isOver21 = ref(false)
    let ssn = ref('')
    let medicaidId = ref('')
    let countyId = ref()
    let ethnicityId = ref()
    let genderId = ref()
    let preferredMethodOfContactId = ref()
    let phoneTypeId = ref()
    let phoneNumber = ref()
    let emailTypeId = ref()
    let emailAddress = ref()        
    let addressTypeId = ref()
    let addressLine1 = ref()
    let addressLine2 = ref()
    let city = ref()
    let stateId = ref()
    let zipCode = ref()
    let showMailing = ref(false)
    let mailingAddressTypeId = ref()
    let mailingAddressLine1 = ref()
    let mailingAddressLine2 = ref()
    let mailingCity = ref()
    let mailingStateId = ref()
    let mailingZipCode = ref()

    let emergencyContactName = ref()
    let emergencyContactContactTypeId = ref()
    let emergencyContactPhoneTypeId = ref()
    let emergencyContactPhoneNumber = ref()
    let emergencyContactEmailTypeId = ref()
    let emergencyContactEmailAddress = ref()
    let emergencyContactAddressTypeId = ref()
    let emergencyContactAddressLine1 = ref()
    let emergencyContactAddressLine2 = ref()
    let emergencyContactCity = ref()
    let emergencyContactStateId = ref()
    let emergencyContactZipCode = ref()
    let emergencyContactPreferredMethodOfContactId = ref()

    let certificationTypeId = ref()
    let cmAgencyWyNumber = ref()

    let isSubmitted = ref(false)

    let statusPending = ref(true);
    let statusDeclined = ref(false);
    let statusAccepted = ref(false);
    let statusMoreInfo = ref(false);

    let person = ref<IPerson | null>(null)
    let personAddresses = ref<IPersonAddress[] | null>(null)
    let personAddress = ref<IPersonAddress | null>(null)
    let personEmail = ref<IPersonEmail | null>(null)
    let personPhone = ref<IPersonPhone | null>(null)
    let personEmergencyContact = ref<IPersonEmergencyContact | null>(null)
    let participantApplicationCmAgencyDocument = ref<IParticipantApplicationDocument | null>(null)
    let cmAgencyDocument = ref<IDocument | null>(null)
    let allowUpload = ref(true)

    LookupService.getDivisions().then(result => divisions.value = result).then(() => isLoading.value = false);
    LookupService.getCounties().then(result => counties.value = result).then(() => isLoading.value = false);
    LookupService.getAddressTypes().then(result => addressTypes.value = result).then(() => isLoading.value = false);
    LookupService.getEmailTypes().then(result => emailTypes.value = result).then(() => isLoading.value = false);
    LookupService.getEthnicities().then(result => ethnicities.value = result).then(() => isLoading.value = false);
    LookupService.getGenders().then(result => genderTypes.value = result).then(() => isLoading.value = false);
    LookupService.getPhoneTypes().then(result => phoneTypes.value = result).then(() => isLoading.value = false);
    LookupService.getPreferredMethodsOfContact().then(result => preferredMethodsOfContact.value = result).then(() => isLoading.value = false);
    LookupService.getContactTypes().then(result => contactTypes.value = result).then(() => isLoading.value = false);
    LookupService.getStates().then(result => states.value = result).then(() => isLoading.value = false);
    
    
    onMounted(async () => {
        console.log('valid: ' + valid);
        try {
            const token = await getAccessToken();

            if (!token) {
                unregistered.value = true;
                registered.value = false;
            } else {
                unregistered.value = false;
                registered.value = true;
                isAuthenticated = auth0 ? auth0.isAuthenticated.value : false;
                auth0User.value = auth0 ? auth0.user.value : null;
                console.log('Application Page is auth0 authenticated: ' + isAuthenticated);
                if (auth0User.value) {
                    auth0UserId.value = auth0User.value.sub; // Access Auth0 user ID
                    //console.log('Auth0 User ID: ' + auth0UserId.value);
                    const returnUser = await UserService.getByAuth0Id(auth0UserId.value);
                    user.value = returnUser;
                    participantPortalUserId.value = user.value.participantPortalUserId;

                    //check if they have an application already
                    const appResult = await ParticipantApplicationService.getByParticipantPortalUserId(participantPortalUserId.value, auth0UserId.value);
                    existingApp.value = appResult;
                    //console.log("existing app:" + JSON.stringify(existingApp.value, null, 2));
                    if (existingApp.value != null && existingApp.value.participantPortalUserId == participantPortalUserId.value) {
                        //don't let them submit again.
                        hasNoApplication.value = false;
                        console.log('existingApp.value.applicationResultId: ' + existingApp.value.applicationResultId);
                        switch (existingApp.value.applicationResultId) {
                            case 0:
                                statusPending.value = true;
                                statusDeclined.value = false;
                                statusAccepted.value = false;
                                statusMoreInfo.value = false;
                                allowUpload.value = false;
                                break;
                            case 1:
                                statusPending.value = false;
                                statusDeclined.value = false;
                                statusAccepted.value = true;
                                statusMoreInfo.value = false;
                                allowUpload.value = false;
                                break;
                            case 2:
                                statusPending.value = false;
                                statusDeclined.value = true;
                                statusAccepted.value = false;
                                statusMoreInfo.value = false;
                                allowUpload.value = false;
                                break;
                            case 3:
                                statusPending.value = false;
                                statusDeclined.value = false;
                                statusAccepted.value = false;
                                statusMoreInfo.value = true;
                                requiresEdit.value = true; // show edit button
                                allowUpload.value = true;
                                break;
                            default:
                                statusPending.value = true;
                                statusDeclined.value = false;
                                statusAccepted.value = false;
                                statusMoreInfo.value = false;
                                allowUpload.value = false;
                                break;
                        }

                        console.log('allow upload: ' + allowUpload.value);
                        cmAgencyWyNumber.value = existingApp.value.caseManagementAgencyWyNumber
                        const personResult = await PersonService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        person.value = personResult;
                        //console.log("Person: " + JSON.stringify(person));
                        const personAddressResult = await PersonAddressService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personAddresses.value = personAddressResult;
                        const personEmailResult = await PersonEmailService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personEmail.value = personEmailResult;
                        const personPhoneResult = await PersonPhoneService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personPhone.value = personPhoneResult;
                        const personEmergencyContactResult = await PersonEmergencyContactService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                        personEmergencyContact.value = personEmergencyContactResult;
                        console.log('existingApp.value.participantApplicationId: ' + existingApp.value.participantApplicationId);
                        if (existingApp.value.participantApplicationId > 0) {
                            const participantApplicationDocumentResult = await ParticipantApplicationDocumentService.getByParticipantApplicationId(existingApp.value.participantApplicationId, auth0UserId.value);
                            participantApplicationCmAgencyDocument.value = participantApplicationDocumentResult;
                            console.log("app doc: " + JSON.stringify(participantApplicationCmAgencyDocument.value));
                            if (participantApplicationCmAgencyDocument.value.documentId > 0) {
                                const cmAgencyDocumentResult = await DocumentService.getByDocumentId(participantApplicationCmAgencyDocument.value.documentId, existingApp.value.personId, auth0UserId.value);
                                cmAgencyDocument.value = cmAgencyDocumentResult;
                                console.log('document id: ' + cmAgencyDocument.value.documentId);
                                console.log('filename: ' + cmAgencyDocument.value.filename);
                            }                           
                        }                        

                        divisionId.value = existingApp.value.applicationDivisionId;
   
                        onDivisionTypeChange();

                        firstName.value = person.value.firstName;
                        middleName.value = person.value.middleName;
                        lastName.value = person.value.lastName;
                        preferredName.value = person.value.preferredName;
                        suffixId.value = person.value.suffixId == 0 ? null : person.value.suffixId;
                        dateOfBirth.value = (new Date(person.value.dateOfBirth).getFullYear() + "-" + String(new Date(person.value.dateOfBirth).getMonth() + 1).padStart(2, '0') + "-" + String(new Date(person.value.dateOfBirth).getDate()).padStart(2, '0'));
                        ssn.value = person.value.ssn;
                        genderId.value = person.value.genderId;
                        ethnicityId.value = person.value.ethnicityId;
                        medicaidId.value = person.value.medicaidId == undefined ? '' : person.value.medicaidId;
                        isMilitary.value = existingApp.value.isActiveMilitary ? true : false;
                        isApplyingForAbi.value = existingApp.value.isApplyingForAbi ? true : false;
                        countyId.value = existingApp.value.countyId;
                        phoneTypeId.value = personPhone.value.phoneTypeId;
                        phoneNumber.value = personPhone.value.phoneNumber;
                        emailTypeId.value = personEmail.value.emailTypeId;
                        emailAddress.value = personEmail.value.emailAddress;

                        emergencyContactName.value = personEmergencyContact.value.personName;
                        emergencyContactContactTypeId.value = personEmergencyContact.value.contactTypeId;
                        emergencyContactPhoneTypeId.value = personEmergencyContact.value.phoneTypeId;
                        emergencyContactPhoneNumber.value = personEmergencyContact.value.phoneNumber;
                        emergencyContactEmailTypeId.value = personEmergencyContact.value.emailTypeId;
                        emergencyContactEmailAddress.value = personEmergencyContact.value.emailAddress;
                        emergencyContactAddressTypeId.value = personEmergencyContact.value.addressTypeId;
                        emergencyContactAddressLine1.value = personEmergencyContact.value.addressLine1;
                        emergencyContactAddressLine2.value = personEmergencyContact.value.addressLine2;
                        emergencyContactCity.value = personEmergencyContact.value.city;
                        emergencyContactStateId.value = personEmergencyContact.value.stateId;
                        emergencyContactZipCode.value = personEmergencyContact.value.zipCode;
                        emergencyContactPreferredMethodOfContactId.value = personEmergencyContact.value.preferredMethodOfContactId;

                        if (personAddresses.value) {
                            personAddresses.value.forEach((singleAddress) => {

                                if (singleAddress.addressTypeId == 2) {
                                    //console.log('Loading Mailing Address, ID: ' + singleAddress.personAddressId);
                                    showMailing.value = true;
                                    mailingAddressTypeId.value = singleAddress.addressTypeId;
                                    mailingAddressLine1.value = singleAddress.addressLine1;
                                    mailingAddressLine2.value = singleAddress.addressLine2;
                                    mailingCity.value = singleAddress.city;
                                    mailingStateId.value = singleAddress.stateId;
                                    mailingZipCode.value = singleAddress.zipCode;
                                } else {
                                    //console.log('Loading Physical Address, ID: ' + singleAddress.personAddressId);
                                    addressTypeId.value = singleAddress.addressTypeId;
                                    addressLine1.value = singleAddress.addressLine1;
                                    addressLine2.value = singleAddress.addressLine2;
                                    city.value = singleAddress.city;
                                    stateId.value = singleAddress.stateId;
                                    zipCode.value = singleAddress.zipCode;
                                }
                            });
                        }

                        preferredMethodOfContactId.value = person.value.preferredMethodOfContactId;


                    } else {
                        hasNoApplication.value = true;
                        allowUpload.value = true;
                    }
                    //console.log('hasNoApplication: ' + hasNoApplication.value);
                }
            }
        } catch (e) {
            //console.log('Not Authenticated.');
            const errorObj = e as Error;
            console.error('Authentication Error: ' + errorObj.message);
        } finally {
            loadingData.value = false;
        }
    });

    watch(allowUpload, () => {
        console.log("Allow Upload: " + allowUpload.value)
    })

    watch(isSubmitted, () => {
        console.log("Submitted Status: " + isSubmitted.value.toString())
    })

    watch(isOver21, () => {
        console.log("Is Over 21: " + isOver21.value)
    })

    watch(dateOfBirth, (newValue) => {
        if (newValue) {
            const today = new Date();
            const birthDate = new Date(newValue);
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();

            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            isOver21.value = age >= 21;
        } else {
            isOver21.value = false;
        }
    });

    // eslint-disable-next-line
    //async function testCaptcha() {
    //    //console.log('Testing Captcha');
    //    var token = await recaptcha();
    //    //console.log('Submit testCaptcha token: ' + token);
    //    if (token != null) {
    //        ParticipantApplicationService.testCaptcha(token)
    //    }
    //}

    // eslint-disable-next-line
    async function saveNewApplication() {
        //console.log('zipCode: ' + zipCode.value);
        //var token = await recaptcha();
        //console.log('Submit testCaptcha token: ' + token);
        //if (token != null) {
            
            try {
                let result = validateForm();
                if (result) {

                    console.log('saving new app')
                                        
                    // get the user
                    if (registered.value == true) {
                        const result = await UserService.getByAuth0Id(auth0UserId.value);
                        user.value = result;
                        participantPortalUserId.value = user.value.participantPortalUserId;
                        console.log('participantPortalUserId:' + participantPortalUserId.value);
                    }
                    const addressTypeId = mailingAddressLine1.value == undefined || mailingAddressLine1.value.trim() === "" ? Number(3) : Number(1);
                    console.log("addressTypeId: " + addressTypeId);
                    const application: IParticipantNewApplication = {
                        participantPortalUserId: participantPortalUserId.value ? Number(participantPortalUserId.value) : undefined,
                        divisionId: Number(divisionId.value),
                        firstName: firstName.value,
                        middleName: middleName.value,
                        lastName: lastName.value,
                        preferredName: preferredName.value ?? '',
                        suffixId: Number(suffixId.value) == 0 ? undefined : Number(suffixId.value),
                        genderId: Number(genderId.value),
                        dateOfBirth: dateOfBirth.value,
                        ssn: ssn.value,
                        medicaidId: medicaidId.value ? medicaidId.value : '',
                        ethnicityId: Number(ethnicityId.value),
                        isActiveMilitary: isMilitary.value.toString(),
                        isApplyingForAbi: isApplyingForAbi.value.toString(),
                        preferredMethodOfContactId: Number(preferredMethodOfContactId.value),
                        countyId: Number(countyId.value),
                        //addressTypeId: mailingAddressLine1.value == undefined || mailingAddressLine1.value == "" ? Number(3) : Number(1),
                        addressTypeId: addressTypeId,
                        addressLine1: addressLine1.value,
                        addressLine2: addressLine2.value ?? '',
                        city: city.value,
                        stateId: Number(stateId.value),
                        zipCode: zipCode.value,
                        mailingAddressTypeId: mailingAddressLine1.value != undefined && mailingAddressLine1.value != "" ? Number(2) : 0,
                        mailingAddressLine1: mailingAddressLine1.value ?? '',
                        mailingAddressLine2: mailingAddressLine2.value ?? '',
                        mailingCity: mailingCity.value ?? '',
                        mailingStateId: Number(mailingStateId.value) ?? 0,
                        mailingZipCode: mailingZipCode.value ?? '',
                        phoneTypeId: Number(phoneTypeId.value),
                        phoneNumber: phoneNumber.value,
                        emailTypeId: Number(emailTypeId.value),
                        emailAddress: emailAddress.value,
                        emergencyContactName: emergencyContactName.value,
                        emergencyContactContactTypeId: emergencyContactContactTypeId.value,
                        emergencyContactPhoneTypeId: Number(emergencyContactPhoneTypeId.value),
                        emergencyContactPhoneNumber: emergencyContactPhoneNumber.value,
                        emergencyContactEmailTypeId: emergencyContactEmailTypeId.value ? Number(emergencyContactEmailTypeId.value) : 0,
                        emergencyContactEmailAddress: emergencyContactEmailAddress.value,
                        emergencyContactAddressTypeId: Number(emergencyContactAddressTypeId.value),
                        emergencyContactAddressLine1: emergencyContactAddressLine1.value,
                        emergencyContactAddressLine2: emergencyContactAddressLine2.value,
                        emergencyContactCity: emergencyContactCity.value,
                        emergencyContactStateId: Number(emergencyContactStateId.value),
                        emergencyContactZipCode: emergencyContactZipCode.value,
                        emergencyContactPreferredMethodOfContactId: emergencyContactPreferredMethodOfContactId.value,
                        caseManagementAgencyWyNumber: cmAgencyWyNumber.value
                    };
                    //console.log('zipCode: ' + zipCode.value);
                    //console.log("Application object:", application);
                    await ParticipantApplicationService.saveNewApplication(application)

                    isSubmitted.value = true
                    console.log('participantPortalUserId at get newApp:' + participantPortalUserId.value);
                    const newApp = await ParticipantApplicationService.getByParticipantPortalUserId(participantPortalUserId.value, auth0UserId.value);
                    existingApp.value = newApp;

                    //associate any updated document to the new application
                    if (cmAgencyDocument?.value?.documentId != null && cmAgencyDocument?.value?.documentId > 0) {
                        console.log('has doc, associate');

                        participantApplicationCmAgencyDocument.value = createParticipantApplicationDocument();
                        participantApplicationCmAgencyDocument.value.documentId = cmAgencyDocument.value.documentId;
                        participantApplicationCmAgencyDocument.value.participantApplicationId = existingApp.value.participantApplicationId;
                        participantApplicationCmAgencyDocument.value.modifiedBy = 'Create';
                        participantApplicationCmAgencyDocument.value.modifiedDate = DateHelper.formatDateLocal(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS');

                        console.log('participant app id: ' + existingApp.value.participantApplicationId);
                        //console.log("app doc: " + JSON.stringify(participantApplicationCmAgencyDocument.value));
                        //participantApplicationCmAgencyDocument.value.participantApplicationId = existingApp.value.participantApplicationId;
                        ParticipantApplicationDocumentService.saveParticipantApplicationDocument(participantApplicationCmAgencyDocument.value, auth0UserId.value);
                    }

                    // redirect to submitted page
                    router.push('submitted');

                } else {
                    isSubmitted.value = false
                }

                console.log("IsSubmitted: " + isSubmitted.value);

            } catch (e: unknown) {
                if (isAxiosError(e)) {
                    console.error(e.response?.data);
                } else {
                    console.error(e); // Log the entire error object if it doesn't have the expected structure
                }
            }

        //}
        
    }

    // eslint-disable-next-line
    async function updateApplication() {

        //var token = await recaptcha();
        //console.log('Submit testCaptcha token: ' + token);
        //if (token != null) {

            try {
                let result = validateForm();
                if (result) {

                    console.log('updating existing app')
                    const appResult = await ParticipantApplicationService.getByParticipantPortalUserId(participantPortalUserId.value, auth0UserId.value);
                    existingApp.value = appResult;
                    existingApp.value.applicationDivisionId = divisionId.value;
                    const personResult = await PersonService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                    person.value = personResult;
                    //console.log("Person: " + JSON.stringify(person));
                    const personAddressResult = await PersonAddressService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                    personAddresses.value = personAddressResult;
                    const personEmailResult = await PersonEmailService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                    personEmail.value = personEmailResult;
                    const personPhoneResult = await PersonPhoneService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                    personPhone.value = personPhoneResult;
                    const personEmergencyContactResult = await PersonEmergencyContactService.getByPersonId(existingApp.value.personId, auth0UserId.value);
                    personEmergencyContact.value = personEmergencyContactResult;

                    person.value.firstName = firstName.value;
                    person.value.middleName = middleName.value;
                    person.value.lastName = lastName.value;
                    person.value.preferredName = preferredName.value;
                    person.value.suffixId = Number(suffixId.value) == 0 ? undefined : Number(suffixId.value);
                    person.value.dateOfBirth = dateOfBirth.value;
                    person.value.ssn = ssn.value;
                    person.value.genderId = Number(genderId.value);
                    person.value.ethnicityId = Number(ethnicityId.value);
                    person.value.medicaidId = medicaidId.value ? medicaidId.value : undefined;
                    existingApp.value.isActiveMilitary = isMilitary.value.toString() == "true" ? true : false;
                    existingApp.value.isApplyingForAbi = isApplyingForAbi.value.toString() == "true" ? true : false;
                    existingApp.value.countyId = Number(countyId.value);
                    existingApp.value.caseManagementAgencyWyNumber = cmAgencyWyNumber.value;
                    personPhone.value.phoneTypeId = Number(phoneTypeId.value);
                    personPhone.value.phoneNumber = phoneNumber.value;
                    personEmail.value.emailTypeId = Number(emailTypeId.value);
                    personEmail.value.emailAddress = emailAddress.value;

                    if (personEmergencyContact.value.personName == null || personEmergencyContact.value.personName == "")
                    {
                        personEmergencyContact.value = createPersonEmergencyContact();
                    }             

                    personEmergencyContact.value.personId = person.value.personId;
                    personEmergencyContact.value.personName = emergencyContactName.value;
                    personEmergencyContact.value.contactTypeId = emergencyContactContactTypeId.value;
                    personEmergencyContact.value.phoneTypeId = Number(emergencyContactPhoneTypeId.value);
                    personEmergencyContact.value.phoneNumber = emergencyContactPhoneNumber.value;
                    personEmergencyContact.value.emailTypeId = emergencyContactEmailTypeId.value ? Number(emergencyContactEmailTypeId.value) : 0;
                    personEmergencyContact.value.emailAddress = emergencyContactEmailAddress.value;
                    personEmergencyContact.value.addressTypeId = Number(emergencyContactAddressTypeId.value);
                    personEmergencyContact.value.addressLine1 = emergencyContactAddressLine1.value;
                    personEmergencyContact.value.addressLine2 = emergencyContactAddressLine2.value;
                    personEmergencyContact.value.city = emergencyContactCity.value;
                    personEmergencyContact.value.stateId = Number(emergencyContactStateId.value);
                    personEmergencyContact.value.zipCode = emergencyContactZipCode.value;
                    personEmergencyContact.value.preferredMethodOfContactId = emergencyContactPreferredMethodOfContactId.value;
                    personEmergencyContact.value.modifiedBy = "Update";
                    personEmergencyContact.value.modifiedDate = DateHelper.formatDateLocal(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS');

                    person.value.preferredMethodOfContactId = preferredMethodOfContactId.value;

                    PersonService.savePerson(person.value, auth0UserId.value);
                    PersonEmailService.savePersonEmail(personEmail.value, auth0UserId.value);
                    PersonPhoneService.savePersonPhone(personPhone.value, auth0UserId.value);
                    PersonEmergencyContactService.savePersonEmergencyContact(personEmergencyContact.value, auth0UserId.value);                    

                    var hasExistingMailing = false;
                    var deletedMailing = false;
                    if (personAddresses.value) {
                        personAddresses.value.forEach((singleAddress) => {
                            if (singleAddress.addressTypeId == 2) {
                                //if (showMailing && mailingAddressLine1.value != undefined && mailingAddressLine1.value != "") {
                                //console.log('Step through addresses for update, showMailing: ' + showMailing.value);
                                //console.log('Step through 2 - mailing Line 1 check: ' + (mailingAddressLine1.value != undefined && mailingAddressLine1.value != ""));
                                if (showMailing.value && (mailingAddressLine1.value != undefined && mailingAddressLine1.value != "")) {
                                    console.log('Updating existing Mailing');
                                    singleAddress.addressLine1 = mailingAddressLine1.value;
                                    singleAddress.addressLine2 = mailingAddressLine2.value;
                                    singleAddress.city = mailingCity.value;
                                    singleAddress.stateId = mailingStateId.value;
                                    singleAddress.zipCode = mailingZipCode.value;
                                    PersonAddressService.savePersonAddress(singleAddress, auth0UserId.value);
                                    hasExistingMailing = true;
                                } else {
                                    //console.log('Deleting existing Mailing: ' + singleAddress.personAddressId);
                                    PersonAddressService.deletePersonAddress(singleAddress.personAddressId, auth0UserId.value);
                                    deletedMailing = true;
                                }
                                
                            } else {
                                //saving 
                                console.log('Updating existing physical');
                                singleAddress.addressLine1 = addressLine1.value;
                                singleAddress.addressLine2 = addressLine2.value;
                                singleAddress.city = city.value;
                                singleAddress.stateId = stateId.value;
                                singleAddress.zipCode = zipCode.value;
                                PersonAddressService.savePersonAddress(singleAddress, auth0UserId.value);
                            }
                        });
                    }

                    if (showMailing.value && !hasExistingMailing && mailingAddressLine1.value != undefined && mailingAddressLine1.value != "") {
                        console.log("Adding New Mailing to Existing App");
                        personAddress.value = createPersonAddress();
                        personAddress.value.personId = person.value.personId;
                        personAddress.value.addressTypeId = 2; //mailing
                        personAddress.value.addressLine1 = mailingAddressLine1.value;
                        personAddress.value.addressLine2 = mailingAddressLine2.value;
                        personAddress.value.city = mailingCity.value;
                        personAddress.value.stateId = mailingStateId.value;
                        personAddress.value.zipCode = mailingZipCode.value;
                        personAddress.value.modifiedBy = "Update";
                        personAddress.value.modifiedDate = DateHelper.formatDateLocal(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS');
                        PersonAddressService.savePersonAddress(personAddress.value, auth0UserId.value);

                        //because we just added a mailing address,we need to make sure the existing address is set to physical and not physical/mailing
                        if (personAddresses.value) {
                            personAddresses.value.forEach((singleAddress) => {
                                if (singleAddress.addressTypeId == 3) {
                                    console.log("Updating existing physical/mailing to physical");
                                    //save the physical address as physical if physical/mailing
                                    singleAddress.addressTypeId = 1;
                                    singleAddress.addressLine1 = addressLine1.value;
                                    singleAddress.addressLine2 = addressLine2.value;
                                    singleAddress.city = city.value;
                                    singleAddress.stateId = stateId.value;
                                    singleAddress.zipCode = zipCode.value;
                                    PersonAddressService.savePersonAddress(singleAddress, auth0UserId.value);
                                }
                            });
                        }
                    }

                    if (deletedMailing) {
                        if (personAddresses.value) {
                            personAddresses.value.forEach((singleAddress) => {
                                if (singleAddress.addressTypeId == 1) {
                                    console.log("Updating existing physical to physical/mailing");
                                    singleAddress.addressTypeId = 3;
                                    singleAddress.addressLine1 = addressLine1.value;
                                    singleAddress.addressLine2 = addressLine2.value;
                                    singleAddress.city = city.value;
                                    singleAddress.stateId = stateId.value;
                                    singleAddress.zipCode = zipCode.value;
                                    PersonAddressService.savePersonAddress(singleAddress, auth0UserId.value);
                                }
                            });
                        }
                    }

                    //TODO: turn this back on to reset the app for review
                    existingApp.value.applicationResultId = 0;
                    ParticipantApplicationService.updateApplication(existingApp.value);

                    isSubmitted.value = true

                    // redirect to submitted page
                    router.push('submitted');

                } else {
                    isSubmitted.value = false
                }

                console.log("IsSubmitted: " + isSubmitted.value);

            } catch (e: unknown) {
                if (isAxiosError(e)) {
                    console.error(e.response?.data);
                } else {
                    console.error(e); // Log the entire error object if it doesn't have the expected structure
                }
            }

        //}
    }

    const handleCmAgencyFileUpload = (event) => {
        const file = event?.target?.files?.[0]; // Extract the first file from the event
        if (!file) {
            console.error("No file selected or invalid event structure:", event);
            return;
        }

        console.log('Valid file selected:', file);

        const reader = new FileReader();

        // Read the file as a Base64 string
        reader.onload = (readerEvent) => {
            const base64Content = readerEvent.target.result.split(",")[1]; // Extract Base64 part
            if (cmAgencyDocument.value) {
                cmAgencyDocument.value = {
                    filename: file.name,
                    contentBase64: base64Content,
                    modifiedBy: "Update",
                    modifiedDate: DateHelper.formatDateLocal(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS'),
                };
                console.log('update existing doc');
            } else {
                console.log('create doc');
                cmAgencyDocument.value = createDocument();
                cmAgencyDocument.value.filename = file.name;
                cmAgencyDocument.value.documentTypeId = 1;
                cmAgencyDocument.value.contentBase64 = base64Content;
                cmAgencyDocument.value.modifiedBy = "Create";
                cmAgencyDocument.value.modifiedDate = DateHelper.formatDateLocal(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS');
                console.log('create doc complete');
                
            }

            console.log("File uploaded successfully:", cmAgencyDocument.value);
            // Call the API to upload the document
            uploadDocumentToApi(cmAgencyDocument.value);
        };

        reader.onerror = (error) => {
            console.error("Error reading file:", error);
        };

        reader.readAsDataURL(file); // Start reading the file
    };



    function downloadFile(content: string, filename: string, mimeType: string = 'application/octet-stream') {
        const blob = DocumentService.base64ToBlob(content, mimeType);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
    }

    async function uploadDocumentToApi (doc: IDocument) {
        console.log("Uploading to API:", doc);
        
        const documentId = await DocumentService.saveDocument(doc, auth0UserId.value);
        //console.log('documentId: ' + documentId);
        if (documentId > 0 && existingApp.value != null && existingApp.value.participantApplicationId != null && existingApp.value.participantApplicationId > 0) {
            console.log("Saved doc, saving to participant app");
            cmAgencyDocument.value.documentId = documentId;
            //ParticipantApplicationService.updateApplication(existingApp.value);
            if (participantApplicationCmAgencyDocument.value && participantApplicationCmAgencyDocument.value.participantApplicationDocumentId > 0) {
                participantApplicationCmAgencyDocument.value.documentId = documentId;
            } else {
                participantApplicationCmAgencyDocument.value = createParticipantApplicationDocument();
                participantApplicationCmAgencyDocument.value.documentId = documentId;
                participantApplicationCmAgencyDocument.value.participantApplicationId = existingApp.value.participantApplicationId;
                participantApplicationCmAgencyDocument.value.modifiedBy = 'Create';
            }
            participantApplicationCmAgencyDocument.value.modifiedDate = DateHelper.formatDateLocal(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS');
            
            console.log('participant app id: ' + existingApp.value.participantApplicationId);
            //console.log("app doc: " + JSON.stringify(participantApplicationCmAgencyDocument.value));
            participantApplicationCmAgencyDocument.value.participantApplicationId = existingApp.value.participantApplicationId;
            ParticipantApplicationDocumentService.saveParticipantApplicationDocument(participantApplicationCmAgencyDocument.value, auth0UserId.value);
            const cmAgencyDocResult = ParticipantApplicationDocumentService.getByParticipantApplicationId(existingApp.value.participantApplicationId, auth0UserId.value);
            participantApplicationCmAgencyDocument.value = cmAgencyDocResult;
        } else {
            console.log("Doc not saved to application yet.");

            cmAgencyDocument.value.documentId = documentId;
            console.log('new document id: ' + cmAgencyDocument.value.documentId);
            console.log('new doc filename: ' + cmAgencyDocument.value.filename);
        }
    }

    function validateForm() {
        let isValid = true;
        validationErrors.value = []
        console.log("Errors: " + validationErrors.value)
       // validationErrors.value = '';
        if (divisionId.value == "" || divisionId.value == null) {
            validationErrors.value.push({ text: 'Waiver Program is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (divisionId.value != "" && divisionId.value != null && divisionId.value > 0 && dateOfBirth.value != "" && dateOfBirth.value != null) {
            if (divisionId.value == 2) {
                console.log
                const age = DateHelper.getAge(new Date(dateOfBirth.value));
                if (age < 18) {
                    validationErrors.value.push({ text: 'You must be 18 or older in order to apply for the Community Choices Waiver.' });
                    isValid = false;
                    hasErrors.value = true;
                }
            }
        }
        if (firstName.value == "") { 
            validationErrors.value.push({ text: 'First Name is Required.'});
            isValid = false;
            hasErrors.value = true;
        }
        if (lastName.value == "") {
            validationErrors.value.push({text: 'Last Name is Required.'});
            isValid = false;
            hasErrors.value = true;
        }
        if (dateOfBirth.value == "") {
            validationErrors.value.push({ text: 'Date of Birth is Required.' });
            isValid = false;
            hasErrors.value = true;
        } else {
            if (new Date(dateOfBirth.value) >= new Date()) {
                validationErrors.value.push({ text: 'Date of Birth cannot be a future date.' });
                isValid = false;
                hasErrors.value = true;
            }
        }
        if (ssn.value == "") {
            validationErrors.value.push({ text: 'SSN is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (genderId.value == "" || genderId.value == null) {
            validationErrors.value.push({ text: 'Gender is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (ethnicityId.value == "" || ethnicityId.value == null) {
            validationErrors.value.push({ text: 'Ethnicity is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (countyId.value == "" || countyId.value == null) {
            validationErrors.value.push({ text: 'County is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (phoneTypeId.value == "" || phoneTypeId.value == null) {
            validationErrors.value.push({ text: 'Phone Type is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (phoneNumber.value == "" || phoneNumber.value == null) {
            validationErrors.value.push({ text: 'Phone Number is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emailTypeId.value == "" || emailTypeId.value == null) {
            validationErrors.value.push({ text: 'Email Type is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emailAddress.value == "" || emailAddress.value == null) {
            validationErrors.value.push({ text: 'Email is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        
        //if (addressTypeId.value == "" || addressTypeId.value == null) {
        //    validationErrors.value.push({ text: 'Address Type is Required.' });
        //    isValid = false;
        //    hasErrors.value = true;
        //}
        if (addressLine1.value == "" || addressLine1.value == undefined) {
            validationErrors.value.push({ text: 'Physical Address Line 1 is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (city.value == "" || city.value == undefined) {
            validationErrors.value.push({ text: 'Physical Address City is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (stateId.value == "" || stateId.value == null || stateId.value == undefined) {
            validationErrors.value.push({ text: 'Physical Address State is Required.' });
            isValid = false;
            hasErrors.value = true;
        } else {
            console.log('validating state is Wyoming');
            if (stateId.value != StateEnum.Wyoming) {
                console.log('validating state is Wyoming - fail');
                validationErrors.value.push({ text: 'Physical address must be in Wyoming in order to apply for the waiver.' });
                isValid = false;
                hasErrors.value = true;
            }
        }
        if (zipCode.value == "" || zipCode.value == null || zipCode.value == undefined) {
            validationErrors.value.push({ text: 'Physical Address Zip Code is Required.' });
            isValid = false;
            hasErrors.value = true;
        }

        if (showMailing.value) {
            if (mailingAddressLine1.value == "" || mailingAddressLine1.value == undefined) {
                validationErrors.value.push({ text: 'Mailing Address Line 1 is Required if you have selected &quot;Do you have a different mailing address than the address entered above?&quot;.' });
                isValid = false;
                hasErrors.value = true;
            }
            if (mailingCity.value == "" || mailingCity.value == undefined) {
                validationErrors.value.push({ text: 'Mailing Address City is Required if you have selected &quot;Do you have a different mailing address than the address entered above?&quot;.' });
                isValid = false;
                hasErrors.value = true;
            }
            if (mailingStateId.value == "" || mailingStateId.value == null || mailingStateId.value == undefined) {
                validationErrors.value.push({ text: 'Mailing Address State is Required if you have selected &quot;Do you have a different mailing address than the address entered above?&quot;.' });
                isValid = false;
                hasErrors.value = true;
            }
            if (mailingZipCode.value == "" || mailingZipCode.value == undefined) {
                validationErrors.value.push({ text: 'Mailing Address Zip Code is Required if you have selected &quot;Do you have a different mailing address than the address entered above?&quot;.' });
                isValid = false;
                hasErrors.value = true;
            }
        }

        if (emergencyContactName.value == "" || emergencyContactName.value == null) {
            validationErrors.value.push({ text: 'Emergency Contact Name is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emergencyContactContactTypeId.value == "" || emergencyContactContactTypeId.value == null) {
            validationErrors.value.push({ text: 'Emergency Contact Type is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emergencyContactPhoneTypeId.value == "" || emergencyContactPhoneTypeId.value == null) {
            validationErrors.value.push({ text: 'Emergency Contact Phone Type is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emergencyContactPhoneNumber.value == "" || emergencyContactPhoneNumber.value == null) {
            validationErrors.value.push({ text: 'Emergency Contact Phone Number is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emergencyContactAddressLine1.value == "" || emergencyContactAddressLine1.value == undefined) {
            validationErrors.value.push({ text: 'Emergency Contact Address Line 1 is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emergencyContactCity.value == "" || emergencyContactCity.value == undefined) {
            validationErrors.value.push({ text: 'Emergency Contact Address City is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emergencyContactStateId.value == "" || emergencyContactStateId.value == null || emergencyContactStateId.value == undefined) {
            validationErrors.value.push({ text: 'Emergency Contact Address State is Required.' });
            isValid = false;
            hasErrors.value = true;
        }
        if (emergencyContactZipCode.value == "" || emergencyContactZipCode.value == null || emergencyContactZipCode.value == undefined) {
            validationErrors.value.push({ text: 'Emergency Contact Address Zip Code is Required.' });
            isValid = false;
            hasErrors.value = true;
        }

        if (preferredMethodOfContactId.value == "" || preferredMethodOfContactId.value == null) {
            validationErrors.value.push({ text: 'Preferred Method of Contact is Required.' });
            isValid = false;
            hasErrors.value = true;
        }

        if (cmAgencyWyNumber.value == "" || cmAgencyWyNumber.value == null) {
            validationErrors.value.push({ text: 'Case Management Agency is Required.' });
            isValid = false;
            hasErrors.value = true;
        }

        return isValid;
    }

    function onDivisionTypeChange() {
        //console.log("Selected WaiverType: " + divisionId.value);
        if (divisionId.value == "1") {
            ccwFields.value = false;
            ddFields.value = true;
            certificationTypeId.value = 8; //support
            LookupService.getCmAgencies(certificationTypeId.value, 1).then(result => cmAgencies.value = result).then(() => isLoading.value = false);
        } else if (divisionId.value == "2") {
            ccwFields.value = true;
            ddFields.value = false;
            certificationTypeId.value = 10; //ccw
            LookupService.getCmAgencies(certificationTypeId.value, 3).then(result => cmAgencies.value = result).then(() => isLoading.value = false);
        } else {
            ccwFields.value = false;
            ddFields.value = false;
            unknownWaiver.value = true;
        }
    }

    interface ValidationError {
        text: string;
    }

</script>

<style>
</style>
